import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface MessageTemplate {
  id: string;
  organisationId: string;
  name: string;
  subject: string | null;
  content: string;
  templateType: 'NEWS_FEED' | 'EMAIL_REPLY' | 'ACTION';
  createdAt: string;
  updatedAt: string;
}

export interface CreateTemplateRequest {
  organisationId: string;
  name: string;
  subject?: string;
  content: string;
  type: 'NEWS_FEED' | 'EMAIL_REPLY' | 'ACTION';
}

export interface UpdateTemplateRequest {
  organisationId: string;
  name: string;
  subject?: string;
  content: string;
}

@Injectable({ providedIn: 'root' })
export class MessageTemplateService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiUrl}/api/message-templates`;

  getTemplates(organisationId: string): Observable<MessageTemplate[]> {
    const params = new HttpParams().set('organisationId', organisationId);
    return this.http.get<MessageTemplate[]>(this.baseUrl, { params });
  }

  getTemplatesByType(type: 'NEWS_FEED' | 'EMAIL_REPLY' | 'ACTION', organisationId: string): Observable<MessageTemplate[]> {
    const params = new HttpParams().set('organisationId', organisationId);
    return this.http.get<MessageTemplate[]>(`${this.baseUrl}/type/${type}`, { params });
  }

  createTemplate(request: CreateTemplateRequest): Observable<MessageTemplate> {
    return this.http.post<MessageTemplate>(this.baseUrl, request);
  }

  updateTemplate(id: string, request: UpdateTemplateRequest): Observable<MessageTemplate> {
    return this.http.put<MessageTemplate>(`${this.baseUrl}/${id}`, request);
  }

  deleteTemplate(id: string, organisationId: string): Observable<void> {
    const params = new HttpParams().set('organisationId', organisationId);
    return this.http.delete<void>(`${this.baseUrl}/${id}`, { params });
  }
}
